import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, LightningElement } from "lwc";
import _tmpl from "./recommendations.html";
import { WireStore } from '@oneappexchange/lwc-wired';
import { PopoverHorizontalOrientation, PopoverVerticalOrientation } from 'ace/popover';
import { TilesDataFormat } from '~/components/amc/tilesGrid/enums';
import { AnalyticsEventTopic, buildSearchEvent, SEARCH_RESULT_CLICK_ACTION } from '~/modules/analytics/analyticsHelper';
import { calculateGridItemSize, calculateMaxRecords } from '~/modules/helpers/gridItemHelper';
import { navigateEvent } from '~/modules/helpers/navigationHelper';
import { WireI18n } from '~/modules/stores/i18nStore';
import { recommendationStore, selectSearchContext } from '~/modules/stores/recommendationStore';
import { userStore } from '~/modules/stores/userStore';
class Recommendations extends LightningElement {
  constructor(...args) {
    super(...args);
    this.records = [];
    this.isLoading = true;
    this.isError = false;
    this.isEmpty = true;
    this.labels = void 0;
    this._props = void 0;
    // @ts-expect-error * Automated Type Error Fix
    this.variant = void 0;
    // @ts-expect-error * Automated Type Error Fix
    this.gridItemSize = void 0;
    this.tooltip = void 0;
    this.maxRecords = 9;
    this.isGuestUser = true;
  }
  setCurrentUser(userState) {
    if (this.isGuestUser !== userState.isGuestUser) {
      this.isGuestUser = userState.isGuestUser;
      this.calculateSizes(userState.isGuestUser);
    }
  }
  calculateSizes(isGuestUser) {
    this.gridItemSize = calculateGridItemSize(isGuestUser, this._props);
    // if dims is empty 9 is max number of records
    this.maxRecords = calculateMaxRecords(isGuestUser, this._props, 9);
  }
  set props(value) {
    this._props = value;
    this.variant = value.variant || 'stack';
    if (value.tooltip) {
      this.tooltip = value.tooltip;
    }
    this.calculateSizes(userStore.getState().isGuestUser);
    this.fetchRecords();
  }
  get props() {
    return {
      format: 'listing'
    };
  }
  get hasTooltip() {
    return this.tooltip !== undefined;
  }
  get storeName() {
    return this._props?.url;
  }
  get popoverOrientation() {
    const popoverOrientation = {
      vertical: PopoverVerticalOrientation.TOP,
      horizontal: PopoverHorizontalOrientation.RIGHT
    };
    return popoverOrientation;
  }
  fetchRecords(retry) {
    if (this._props?.url) {
      let tbidToken;
      if (userStore.getState().access_token) {
        // @ts-expect-error * Automated Type Error Fix
        tbidToken = userStore.getState().access_token;
      }
      // @ts-expect-error * Automated Type Error Fix
      recommendationStore.fetchSection(this._props.url, tbidToken, retry);
    }
  }

  //, selector: (state) => state['$name']
  // @ts-expect-error * Automated Type Error Fix
  // @ts-expect-error * Automated Type Error Fix
  setRecords(data, error) {
    const sections = data[this.storeName];
    if (sections && this.isEmpty) {
      this.isLoading = false;
      if (!sections || sections.records.length === 0) {
        this.isEmpty = true;
        this.isError = sections.isError;
      } else {
        this.isEmpty = false;
        this.records = sections.records
        // @ts-expect-error * Automated Type Error Fix
        ?.filter(section => section.listings?.length > 0)
        // @ts-expect-error * Automated Type Error Fix
        .map(section => {
          const _section = {
            ...section
          };
          let showMore = {
            ...this._props._showMore
          };
          if (showMore && showMore.url) {
            const url = showMore.url;
            if (url.includes('{path}')) {
              let value = section.value;
              if (showMore.paths && value) {
                value = showMore.paths[value.toLowerCase()];
              }
              if (value) {
                showMore.url = url.replace(/{.+}/, value);
              } else {
                // @ts-expect-error * Automated Type Error Fix
                showMore = undefined;
              }
            }
            _section.props = {
              ...this._props,
              showMore
            };
          }
          const title = this._props.title;
          if (title) {
            _section.props = {
              ..._section.props,
              title: section.value ? title.replace(/{.+}/, this.getSectionLabel(section.value) || section.value) : title
            };
          }
          _section.records = section.listings?.slice(0, this.maxRecords);
          _section.isLoading = this.isError = false;
          _section.hasTooltip = this._props.tooltip !== undefined;
          _section.props = {
            ..._section.props,
            format: TilesDataFormat.Listing,
            variant: this.variant,
            gridItemSize: this.gridItemSize,
            tooltip: this._props.tooltip,
            id: section.id
          };
          return _section;
        });

        // @ts-expect-error * Automated Type Error Fix
        sections.records.forEach(section => {
          this.dispatchEvent(buildSearchEvent(section, this.storeName));
        });
      }
    } else if (error) {
      this.isError = true; // in this case is not connected to store
    }
  }
  handleNavigate(event) {
    if (event.detail?.listing?.listingUrl) {
      const url = event.detail.listing.listingUrl;
      navigateEvent(url, event.detail.event);
    }
  }
  getSectionLabel(value) {
    if (this.storeName === 'role') {
      // @ts-expect-error * Automated Type Error Fix
      return this.labels.homePageSections.role[value];
    }
    if (['industry', 'product'].includes(this.storeName)) {
      const label = `${value.replace(/ /g, '_').toLowerCase()}`;
      // @ts-expect-error * Automated Type Error Fix
      return this.labels.homePageSections[this.storeName][label];
    }
    return value;
  }

  // @ts-expect-error * Automated Type Error Fix
  handleLog(event) {
    console.log(event);
  }
  handleRetry() {
    this.fetchRecords(true);
  }
  handleAnalytics(event) {
    // We only want to add more information to click events
    if (event.detail.eventType === 'click') {
      // grab the specific listing
      const context = selectSearchContext(recommendationStore.getState(), event.detail.tiles.id, event.detail.listing.oafId);
      event.detail.topic = AnalyticsEventTopic.ANALYTICS_CLICK;
      event.detail.searchContext = {
        ...context,
        eventAction: SEARCH_RESULT_CLICK_ACTION,
        type: this._props.url
      };
    }
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(Recommendations, {
  publicProps: {
    props: {
      config: 3
    },
    hasTooltip: {
      config: 1
    }
  },
  track: {
    records: 1,
    isLoading: 1,
    isError: 1,
    isEmpty: 1,
    _props: 1,
    variant: 1,
    gridItemSize: 1,
    tooltip: 1
  },
  wire: {
    labels: {
      adapter: WireI18n,
      dynamic: [],
      config: function ($cmp) {
        return {
          selector: i18n => i18n.recommendations
        };
      }
    },
    setCurrentUser: {
      adapter: WireStore,
      dynamic: [],
      method: 1,
      config: function ($cmp) {
        return {
          store: userStore
        };
      }
    },
    setRecords: {
      adapter: WireStore,
      dynamic: [],
      method: 1,
      config: function ($cmp) {
        return {
          store: recommendationStore,
          selector: state => state.sections
        };
      }
    }
  },
  fields: ["maxRecords", "isGuestUser"]
});
const __lwc_component_class_internal = _registerComponent(Recommendations, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;